const other = [
    //-------------------其他--------------------------------------
    //落地页
    {
      path: '/other/thirdpartyredirect/tianxiaxinyong',
      component: () => import('@/pages/other/third-party-redirect/tianxiaxinyong.vue'),
      meta: {
        title: '智借',
        keepAlive: false
      }
    },
    {
      path: '/other/about',
      name: 'OtherAbout',
      component: () => import('@/pages/other/about/index.vue'),
      meta: {
        title: '关于我们',
        keepAlive: true
      }
    }, {
      path: '/other/agreement',
      name: 'OtherAgreement',
      component: () => import('@/pages/other/agreement/index.vue'),
      meta: {
        title: '协议',
        keepAlive: true
      }
    },
    {
      path: '/other/rick-notice-detail',
      component: () => import('@/pages/other/about/rick-notice-detail.vue'),
      meta: {
        title: '反诈提醒'
      }
    },
  ]
  export default other



// WEBPACK FOOTER //
// ./src/router/modules/other.js